import { ApplicationRef } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { rootReducer } from 'ChartApp/ts/apps/fund-chart/state/fund-chart.reducer';
import { FundChartPageModule } from 'ChartApp/ts/apps/fund-chart/app.module';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { FundChartPageComponent } from 'ChartApp/ts/apps/fund-chart/components/fund-chart-page/fund-chart-page.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class MutualFundsFundChartModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(FundChartPageComponent);
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(SideMenuComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
    }
}
MutualFundsFundChartModule.ɵfac = function MutualFundsFundChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsFundChartModule)(); };
MutualFundsFundChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsFundChartModule });
MutualFundsFundChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [
        // FundChartPageModule must be imported before BaseSecurityPageModule because
        // FundChartPageModule imports HttpClientJsonpModule module, and
        // HttpClientJsonpModule must be imported before BaseSecurityPageModule
        // to prevent X-CSRFToken header from being included in
        // jsonp requests https://github.com/angular/angular/issues/47312
        FundChartPageModule,
        BaseSecurityPageModule,
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() })] });
